const filters =
  [
    {
      name: 'dateFull',
      execute: (data) => {
        let date = new Date(data * 1000)
        let year = date.getFullYear()
        let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
        let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
        let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
        let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      }
    },
    {
      name: 'dateOnly',
      execute: (data) => {
        let date = new Date(data * 1000)
        let year = date.getFullYear()
        let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
        return year + '-' + month + '-' + day
      }
    },
    {
      name: 'monthDayOnly',
      execute: (data) => {
        let date = new Date(data * 1000)
        let year = date.getFullYear()
        let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
        return month + '-' + day
      }
    },
    {
      name: 'timeOnly',
      execute: (data) => {
        let date = new Date(data * 1000)
        let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
        let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
        let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
        return hours + ':' + minutes + ':' + seconds
      }
    }
    ,
    {
      name: 'timeOnlyWithoutSeconds',
      execute: (data) => {
        let date = new Date(data * 1000)
        let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
        let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
        return hours + ':' + minutes
      }
    },
    {
      name: 'timeLeftFormatMinute',
      execute: (data) => {
        let time = ''
        let minute = Math.floor(data / 60)
        let seconds = data % 60
        minute = minute < 10 ? '0' + minute : minute
        seconds = seconds < 10 ? '0' + seconds : seconds
        time = minute + ':' + seconds
        return time
      }
    },
    {
      name: 'absoluteValue',
      execute: (value) => {
        return Math.abs(value)
      }
    },
    {
      name: 'waitObj',
      execute: (value) => {
        return value ? value : ''
      }
    },
    {
      name: 'fixedTwo',
      execute: (value) => {
        return +value.toFixed(2)
      }
    },
    {
      name: 'sliceTextMore100Symbol',
      execute: (value) => {
        let valueString = value.toString()
        return valueString.length > 70 ? valueString.slice(0, 70) + '...' : valueString
      }
    },
    {
      name: 'shortHash',
      execute: (value) => {
        let lastForSymbols = value ? value.slice(-4) : ''
        return lastForSymbols
      }
    },
  ]

export default filters



// WEBPACK FOOTER //
// ./src/filters/filters.js